import Validator from 'validatorjs';
import {login, forgotPassword, resetPasswordRules, profile, changePassword, registration} from './rules';

const validateUserLogin = (values) => {
  const validation = new Validator(values, login);
  if (validation.passes()) {
    return {};
  } else {
    return validation.errors.all();
  }
};

const validateForgotPassword = (values) => {
  const validation = new Validator(values, forgotPassword);
  if (validation.passes()) {
    return {};
  } else {
    return validation.errors.all();
  }
};

export const validateResetPassword = ({password, confirmation}) => {
  const validation = new Validator(
    {password, confirmation},
    resetPasswordRules
  );
  return !validation.passes()
    ? validation.errors.all()
    : password !== confirmation
      ? { confirmation: 'Passwords do not match.'}
      : {};
};

const validateProfile = (values) => {
  const validation = new Validator(values, profile);
  validation.setAttributeNames({
    firstName: 'first name',
    lastName: 'last name'
  });
  if (validation.passes()) {
    return {};
  } else {
    return validation.errors.all();
  }
};

const validateChangePassword = (values) => {
  const validation = new Validator(values, changePassword, {
    same: 'The confirm new password and new password fields must match.'
  });
  validation.setAttributeNames({
    oldPassword: 'old password',
    newPassword: 'new password',
    confirmNewPassword: 'confirm new password'
  });
  if (validation.passes()) {
    return {};
  } else {
    return validation.errors.all();
  }
};

const validateUserRegistration = (values) => {
  const validation = new Validator(values, registration);
  validation.setAttributeNames({
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    companyName: 'Company Name',
    companyAddress1: 'Address 1',
    city: 'City',
    state: 'State',
    zip: 'Zip',
    phoneNumber: 'Phone Number',
    BrokerIsCorrespondent: 'correspondent lender',
    companySelection: 'company selection'
  });  
  if (validation.passes()) {
    return {};
  } else {
    return validation.errors.all();
  }
};

export {
  validateUserLogin,
  validateForgotPassword,
  validateProfile,
  validateChangePassword,
  validateUserRegistration
};
